module.exports = __webpack_public_path__ + "img/bank-bri.f51628fc.png";